module.exports = __webpack_public_path__ + "media/images/home/nl/preview-2-e6bfea20e7fb5aec1f577ac586b471ee.jpg";